export interface ResponseInterface {
  status_code: number;
  message?: string;
}

export default ResponseInterface;
